import React, { Component } from 'react';
import {
  CardContainer,
  CardWrapper,
  InfoCard,
  TipusIconWrapper,
  NomResultat,
  VisualitzarIconWrapper,
  InfoAuxiliar,
  InfoWrapper,
  InfoCardSVG
} from './ResultatInfoCardElement';
import proj4 from 'proj4';
import { config } from '../../../config/Config';

export default class ResultatInfoCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  /**
   * @desc función encargada de tratar el evento de click en un resultado de la cerca
   */
  onClickCard = () => {
    if (this.props.isCapes === 'localitzacions') {
      //si es un element, es farà zoom a la seva posició al mapa

      if (this.props.arCoords) {
        let coordenades = [parseFloat(this.props.arCoords.X['#text']), parseFloat(this.props.arCoords.Y['#text'])];
        let coordsProj = proj4(config.EPSG, config.EPSG_mapa, coordenades);
        this.props.onClickElementCerca(coordsProj, true, false, false, this.props.identificador, this.props.capa);
      } else {
        let splittedAddress = this.props.nomCapa.split('.').map((value) => {
          return value.trim();
        });
        let newAddress = '';
        if (splittedAddress[2]) {
          newAddress = splittedAddress[2] + ';' + splittedAddress[0] + ';' + splittedAddress[1];
        } else {
          newAddress = splittedAddress[1] + ';;' + splittedAddress[0];
        }

        this.props.clickAdreça(newAddress);

        // cercaAdreça(undefined, undefined, undefined, newAddress, undefined, true);
      }
    } else if (this.props.isCapes === 'elements') {
      let coordenades = [parseFloat(this.props.arCoords[0]), parseFloat(this.props.arCoords[1])];
      let coordsProj = proj4(config.EPSG, config.EPSG_mapa, coordenades);
      this.props.onClickElementCerca(coordsProj, true, false, true, this.props.identificador, this.props.capa);
    } else {
      //si es una capa, s'afeguirà a la llegenda
      this.props.addLayerToLlegenda(this.props.capa);
    }
  };

  render() {
    return (
      <CardContainer id={'CardContainer' + this.props.isCapes} onClick={() => this.onClickCard()}>
        <CardWrapper id={'CardWrapper' + this.props.isCapes}>
          <InfoCard id={'InfoCard' + this.props.isCapes}>
            <TipusIconWrapper id={'IconWrapper' + this.props.isCapes}>
              {this.props.isCapes === 'capes' ? (
                <InfoCardSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="white" id={'Icon' + this.props.isCapes}>
                  <path
                    d="M12,18.54L19.37,12.8L21,14.07L12,21.07L3,14.07L4.62,12.81L12,18.54M12,16L3,9L12,2L21,9L12,16M12,4.53L6.26,9L12,13.47L17.74,9L12,4.53Z"
                    id={'Icon' + this.props.isCapes}
                  />
                </InfoCardSVG>
              ) : (
                <InfoCardSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="white" id={'Icon' + this.props.isCapes}>
                  <path
                    d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
                    id={'Icon' + this.props.isCapes}
                  />
                </InfoCardSVG>
              )}
            </TipusIconWrapper>
            <InfoWrapper id={'InfoWrapper' + this.props.isCapes}>
              <NomResultat id={'NomResultat' + this.props.isCapes} title={this.props.nomCapa} fontSizeEnabled={this.props.fontSizeEnabled}>
                {this.props.nomCapa}
              </NomResultat>
              <InfoAuxiliar id={'InfoAuxiliar' + this.props.isCapes} title={this.props.infoAux} fontSizeEnabled={this.props.fontSizeEnabled}>
                {this.props.infoAux}
              </InfoAuxiliar>
            </InfoWrapper>
          </InfoCard>
          <VisualitzarIconWrapper id={'Visualitzar' + this.props.isCapes}>
            <InfoCardSVG fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 24 24" fill="white" id={'VisualitzarIcon' + this.props.isCapes}>
              <path
                id={'VisualitzarIcon' + this.props.isCapes}
                d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z"
              />
            </InfoCardSVG>
          </VisualitzarIconWrapper>
        </CardWrapper>
      </CardContainer>
    );
  }
}
